// extracted by mini-css-extract-plugin
export default {"parentOffer":"styles_parentOffer__JHs1B","title":"styles_title__ewSWD","subHeading":"styles_subHeading__hkT49"};